var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('sidebar-nav'),_vm._v(" "),_c('navbar-page'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('footer-basic')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }